__turbopack_context__.v({
  "mantine-Input-input": "CreateNewOrganizationForm-module__7I-ayG__mantine-Input-input",
  "mantine-Input-wrapper": "CreateNewOrganizationForm-module__7I-ayG__mantine-Input-wrapper",
  "mantine-NumberInput-input": "CreateNewOrganizationForm-module__7I-ayG__mantine-NumberInput-input",
  "mantine-Select-input": "CreateNewOrganizationForm-module__7I-ayG__mantine-Select-input",
  "transparentBackground": "CreateNewOrganizationForm-module__7I-ayG__transparentBackground",
});
